/*
 * @Author: your name
 * @Date: 2021-11-29 11:20:23
 * @LastEditTime: 2021-11-29 11:50:47
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \cpms-admin\src\views\ticket\ticket.routing.ts
 */
import { RouterView } from "vue-router";
import { MakeTicketRouting } from "./makeTicket/makeTicket.routing";
import {IncomeTicketRouting} from "./incomeTicket/incomeTicket.routing";

export const TicketRouting = {
  path: "/ticket",
  name: "ticket",
  redirect: "/ticket/list",
  component: RouterView,
  meta: { title: "发票(财务)", icon: "fapiao" },
  children: [
	 ...IncomeTicketRouting,
    ...MakeTicketRouting
   
  ],
};
